import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../../seo/SEO';
import './package-listing.scss';

const categories = [
  { id: 'all', label: 'All' },
  { id: 'chardham', label: 'CharDham' },
  { id: 'jyotirlinga', label: 'Jyotirlinga' },
  { id: 'shakti-peeth', label: 'Shakti Peeth' },
];

const highlights = [
  {
    id: 1,
    title: 'Assisted Darshan',
    desc: 'Priority darshan support at every shrine',
  },
  {
    id: 2,
    title: 'Best Price',
    desc: 'No hidden charges, transparent pricing',
  },
  {
    id: 3,
    title: '24x7 Support',
    desc: 'Dedicated yatra manager on every trip',
  },
];

const packagesList = [
  {
    id: 'vaishno-devi',
    title: 'Vaishno Devi ',
    route: 'Jammu • Katra • Bhawan',
    badge: 'Bestseller',
    image: '/assets/packages/vaishno-devi.webp',
    categories: ['chardham', 'shakti-peeth'],
    duration: '10 Days / 9 Nights',
    price: '₹ 28,500',
    originalPrice: '₹ 34,000',
    dedicatedUrl: '/vaishno-devi-package',
  },
  {
    id: 'varanasi-package',
    title: 'Varanasi Tour Package',
    route: 'Varanasi • Sarnath • Prayagraj',
    badge: 'Bestseller',
    image: '/assets/packages/varanasi.webp',
    categories: ['jyotirlinga'],
    duration: '4 Days / 3 Nights',
    price: '₹ 12,499',
    originalPrice: '₹ 15,200',
    dedicatedUrl: '/varanasi-package',
  },
];

export default function PackageListing() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.title = 'Pilgrimage Packages | MandirWiki';
  }, []);

  const filteredPackages = packagesList.filter((pkg) => {
    if (activeCategory === 'all') return true;
    return pkg.categories.includes(activeCategory);
  });

  const handleViewPackage = (pkg) => {
    if (pkg.dedicatedUrl) {
      navigate(pkg.dedicatedUrl);
    }
  };

  return (
    <div className="packageListingPage">

      {/* ========================================================
          1. HERO BANNER WITH IMAGE & STATIC CONTENT
      ======================================================== */}
      <SEO pageKey="packageListing" />
      <div className="pkgHeroSection">
        <div className="pkgBannerWrapper">
          <div className="container">
            <div className="bannerContent">
              <h1 className="bannerMainHeading">
                Pilgrimage Packages for <br />
                Every Devotee
              </h1>
              <p className="bannerSubDescription">
                Char Dham, Jyotirlingas, Shakti Peeths and more curated yatras with darshan assistance, comfortable stays and caring guides.
              </p>
            </div>
          </div>
        </div>
      </div>


      {/* ========================================================
          2. FEATURE HIGHLIGHTS BAR (BOOTSTRAP 5 GRID)
      ======================================================== */}
      <section className="pkgHighlightsSection">
        <div className="container">
          <div className="row g-3 align-items-center">
            {highlights.map((item) => (
              <div key={item.id} className="col-12 col-md-4">
                <div className="highlightCard">
                  <span className="goldCircleIcon" />
                  <div className="highlightContent">
                    <h3 className="highlightTitle">{item.title}</h3>
                    <p className="highlightDesc">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* ========================================================
          3. ALL YATRA PACKAGES (BOOTSTRAP 5 GRID - COL-LG-4)
      ======================================================== */}
      <section className="pkgGridSection">
        <div className="container">
          {/* Section Heading, Subtitle & Filter Pills - Centered (Matches Design) */}
          <div className="sectionHeader text-center">
            <h2 className="sectionMainTitle">All Yatra Packages</h2>
            <p className="sectionSubTitle">
              8 handpicked pilgrimage tours across India
            </p>

            {/* Filter Pills Centered */}
            <div className="categoryPillList">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  type="button"
                  className={`categoryPill ${activeCategory === cat.id ? 'active' : ''}`}
                  onClick={() => setActiveCategory(cat.id)}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>

          {/* Bootstrap 5 Grid (col-lg-4) */}
          <div className="row g-4">
            {filteredPackages.map((pkg) => (
              <div key={pkg.id} className="col-12 col-md-6 col-lg-4">
                <div className="packageCard h-100">
                  {/* Image Container with Badge */}
                  <div className="cardImageWrapper">
                    {pkg.badge && <span className="cardBadge">{pkg.badge}</span>}
                    <img
                      src={pkg.image}
                      alt={pkg.title}
                      className="cardImage"
                      loading="lazy"
                    />
                  </div>

                  {/* Card Content */}
                  <div className="cardBody d-flex flex-column">
                    <h3 className="cardTitle">{pkg.title}</h3>
                    <p className="cardRoute flex-grow-1">{pkg.route}</p>

                    <button
                      type="button"
                      className="viewPackageBtn mt-auto"
                      onClick={() => handleViewPackage(pkg)}
                    >
                      View Package
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
